var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-background",style:(_vm.backgroundImage)},[_c('div',{staticClass:"login-title login-title--right typo--1 t-left",attrs:{"size":"m"},domProps:{"innerHTML":_vm._s(_vm.titleRight)}})])}
var staticRenderFns = []

export { render, staticRenderFns }